import { render, staticRenderFns } from "./ForumArticle.vue?vue&type=template&id=07c7b004&scoped=true"
import script from "./ForumArticle.vue?vue&type=script&lang=ts"
export * from "./ForumArticle.vue?vue&type=script&lang=ts"
import style0 from "./ForumArticle.vue?vue&type=style&index=0&id=07c7b004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c7b004",
  null
  
)

export default component.exports